import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Modal from '../../shared/modals/modal.component';
import Button from '../../shared/button.component';

const DeleteAdminTaxEntryModal = ({
  hideModal,
  resetReportParameters,
  resetReportFilters,
  isVisible,
}) => {
  const resetAll = useCallback(() => {
    resetReportParameters();
    resetReportFilters();
    hideModal();
  }, [hideModal, resetReportParameters, resetReportFilters]);

  const resetParameters = useCallback(() => {
    resetReportParameters();
    hideModal();
  }, [hideModal, resetReportParameters]);

  const resetFilters = useCallback(() => {
    resetReportFilters();
    hideModal();
  }, [hideModal, resetReportFilters]);

  return (
    <Modal
      className="custom-report-reset-modal"
      dismissText="Cancel"
      title="Reset Custom Report"
      closeAction={hideModal}
      dismissAction={hideModal}
      isVisible={isVisible}
    >
      <div className="button-grid">
        <div>
          <Button
            type="button"
            kind="primary"
            size="lg"
            onClick={resetAll}
          >
            Reset All
          </Button>
        </div>
        <span>Reset both parameters and filters</span>

        <div>
          <Button
            type="button"
            kind="primary"
            size="lg"
            onClick={resetParameters}
          >
            Reset Parameters
          </Button>
        </div>
        <span>Reset report parameter dropdowns</span>

        <div>
          <Button
            type="button"
            kind="primary"
            size="lg"
            onClick={resetFilters}
          >
            Reset Filters
          </Button>
        </div>
        <span>Reset grid filters, sorting and columns</span>

      </div>
    </Modal>
  );
};

DeleteAdminTaxEntryModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  resetReportParameters: PropTypes.func.isRequired,
  resetReportFilters: PropTypes.func.isRequired,
  isVisible: PropTypes.bool,
};

export default DeleteAdminTaxEntryModal;
